(() => {
  if (window.CaffreyBrilliance) return;
  const instances = new Map();
  const anatomies = new Map();
  function mount(root) {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const {signal} = controller;
    const form = root.querySelector('[data-br-form]');
    const strings = JSON.parse(root.querySelector('[data-br-strings]').textContent);
    const feedback = root.querySelector('[data-br-feedback]');
    const sticky = root.querySelector('[data-br-sticky]');
    const dialog = root.querySelector('[data-br-dialog]');
    const zoom = root.querySelector('[data-br-zoom]');
    let busy = false;
    const selected = () => root.querySelector('[data-br-variant]:checked');
    function buttons() {
      root.querySelectorAll('[data-br-add]').forEach(button => {
        button.disabled = busy || selected().dataset.available !== 'true';
        button.textContent = busy ? strings.adding : selected().dataset.available === 'true' ? strings.add : strings.sold;
      });
    }
    function sync(updateUrl = true) {
      const v = selected();
      root.querySelectorAll('[data-br-price]').forEach(n => n.textContent = v.dataset.price);
      root.querySelector('[data-br-colour]').textContent = v.dataset.title;
      root.querySelector('[data-br-note]').textContent = v.dataset.note;
      const img = root.querySelector('.cf-br-packshot');
      img.src = v.dataset.image;
      img.srcset = [360,540,750,1080,1400].map(w => {const u = new URL(v.dataset.image,location.href);u.searchParams.set('width',w);return `${u.href} ${w}w`;}).join(', ');
      img.alt = v.dataset.alt;
      zoom.href = v.dataset.zoom;
      const large = root.querySelector('[data-br-zoom-image]');large.src = v.dataset.zoom;large.alt = v.dataset.alt;
      document.querySelectorAll('[data-br-shade]').forEach(card => card.dataset.active = String(card.dataset.brShade === v.value));
      if (updateUrl) {const url = new URL(location.href);url.searchParams.set('variant',v.value);history.replaceState({},'',url);}
      buttons();
    }
    function positionSticky() {
      const r = form.getBoundingClientRect();
      const footer = document.querySelector('footer');
      const nearFooter = footer && footer.getBoundingClientRect().top < innerHeight;
      const nativeOverlay = document.querySelector('cart-drawer.active, cart-notification .active');
      sticky.hidden = r.bottom > 0 || nearFooter || !!nativeOverlay || dialog.open;
    }
    root.addEventListener('change', e => {if(e.target.matches('[data-br-variant]')){feedback.textContent='';sync();}}, {signal});
    form.addEventListener('submit', async e => {
      e.preventDefault();if(busy || !form.reportValidity())return;
      busy=true;buttons();feedback.textContent='';feedback.dataset.error='false';
      const cart=document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const data=new FormData(form);
      if(cart?.getSectionsToRender){data.append('sections',cart.getSectionsToRender().map(s=>s.id).join(','));data.append('sections_url',location.pathname);cart.setActiveElement?.(document.activeElement);}
      try{
        const url=(window.routes?.cart_add_url || '/cart/add')+'.js';
        const response=await fetch(url,{method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:data});
        const result=await response.json().catch(()=>null);
        if(!response.ok || !result || result.status)throw new Error(result?.description || strings.error);
        feedback.textContent=strings.added;
        if(cart?.renderContents)cart.renderContents(result);
        else location.href=window.routes?.cart_url || '/cart';
      }catch(error){feedback.textContent=error instanceof TypeError ? strings.error : error.message || strings.error;feedback.dataset.error='true';}
      finally{busy=false;buttons();positionSticky();}
    },{signal});
    zoom.addEventListener('click',e=>{if(typeof dialog.showModal!=='function')return;e.preventDefault();dialog.showModal();positionSticky();},{signal});
    root.querySelector('[data-br-close]').addEventListener('click',()=>dialog.close(),{signal});
    dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left || e.clientX>r.right || e.clientY<r.top || e.clientY>r.bottom)dialog.close();}},{signal});
    dialog.addEventListener('close',()=>{zoom.focus({preventScroll:true});positionSticky();},{signal});
    let ticking=false;
    const onScroll=()=>{if(ticking)return;ticking=true;requestAnimationFrame(()=>{ticking=false;positionSticky();});};
    window.addEventListener('scroll',onScroll,{passive:true,signal});window.addEventListener('resize',onScroll,{passive:true,signal});
    sync(false);positionSticky();root.dataset.brReady='true';
    instances.set(root,{controller,sync,positionSticky});
  }
  function mountAnatomy(root) {
    const controls = root.querySelector('[data-br-anatomy-controls]');
    if (!controls || anatomies.has(root)) return;
    const controller = new AbortController();
    const {signal} = controller;
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const playback = controls.querySelector('[data-br-motion]');
    let observer, timer;
    let visible = false;
    let paused = false;
    const automatic = () => !motion.matches && !window.Shopify?.designMode && 'IntersectionObserver' in window;
    const clear = () => {clearTimeout(timer);timer = undefined;};
    function show(open) {
      root.dataset.brOpen = String(open);
      controls.querySelectorAll('[data-br-view]').forEach(button => button.setAttribute('aria-pressed', String((button.dataset.brView === 'open') === open)));
    }
    function updatePlayback() {
      if (!playback) return;
      playback.hidden = !automatic();
      playback.dataset.brPaused = String(paused);
      const label = paused ? playback.dataset.playLabel : playback.dataset.pauseLabel;
      playback.setAttribute('aria-label', label);
      playback.title = label;
    }
    function queue(delay) {
      clear();
      if (!automatic() || paused || !visible || document.hidden) return;
      timer = setTimeout(() => {
        show(root.dataset.brOpen !== 'true');
        queue(root.dataset.brOpen === 'true' ? 4400 : 2200);
      }, delay);
    }
    function choose(open) {
      paused = true;
      clear();
      show(open);
      updatePlayback();
    }
    controls.hidden = false;
    controls.addEventListener('click', e => {
      const button = e.target.closest('[data-br-view]');
      if (button) {choose(button.dataset.brView === 'open');return;}
      if (!e.target.closest('[data-br-motion]')) return;
      paused = !paused;
      updatePlayback();
      if (paused) clear();
      else {show(true);queue(4400);}
    }, {signal});
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        visible = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .25);
        clear();
        if (!automatic() || paused) return;
        if (visible) {show(false);queue(2200);}
        else show(true);
      }, {threshold: [0, .25]});
      observer.observe(root.querySelector('.cf-br-anatomy'));
    }
    motion.addEventListener('change', () => {
      clear();
      show(true);
      updatePlayback();
      queue(4400);
    }, {signal});
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) clear();
      else queue(4400);
    }, {signal});
    signal.addEventListener('abort', () => {clear();observer?.disconnect();}, {once: true});
    show(true);
    updatePlayback();
    root.dataset.brAnatomyReady = 'true';
    anatomies.set(root, {controller, observer, show: choose});
  }
  function init(scope=document){
    if(scope.matches?.('[data-br-main]'))mount(scope);
    scope.querySelectorAll?.('[data-br-main]').forEach(mount);
    if(scope.matches?.('[data-br-anatomy]'))mountAnatomy(scope);
    scope.querySelectorAll?.('[data-br-anatomy]').forEach(mountAnatomy);
    instances.forEach(state => state.sync(false));
  }
  document.addEventListener('click',e=>{const link=e.target.closest('[data-br-pick]');if(!link)return;const root=document.querySelector('[data-br-main]');if(!root)return;const input=root.querySelector(`[data-br-variant][value="${link.dataset.brPick}"]`);if(!input)return;e.preventDefault();input.checked=true;instances.get(root)?.sync();root.querySelector('[data-br-form]').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});input.focus({preventScroll:true});});
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:unload',e=>{
    for(const [root,state] of instances){if(e.target.contains(root)){state.controller.abort();instances.delete(root);}}
    for(const [root,state] of anatomies){if(e.target.contains(root)){state.controller.abort();state.observer?.disconnect();anatomies.delete(root);}}
  });
  document.addEventListener('shopify:section:select',e=>{for(const [root,state] of anatomies){if(e.target.contains(root))state.show(true);}});
  document.addEventListener('shopify:block:select',e=>{for(const [root,state] of anatomies){if(root.contains(e.target))state.show(true);}});
  document.addEventListener('shopify:section:reorder',()=>instances.forEach(s=>s.positionSticky()));
  window.CaffreyBrilliance={init,instances,anatomies};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
})();
